import type { ReactNode } from 'react';
import React from 'react';
import DropDownTextHeader from './DropDownTextHeader';
import DropDownMenu from './DropDownMenu';

type DropDownMenuProps = {
	active: boolean;
	children: ReactNode;
	title: string;
	navItemClassName?: string;
	className?: string;
	onToggle: () => void;
};

export default function DropDownTextMenu(props: DropDownMenuProps) {
	const { active, children, title, onToggle, navItemClassName, className } = props;

	return (
		<DropDownMenu
			active={active}
			className={className}
			navItemClassName={navItemClassName}
			header={
				<button className="drop-btn" onClick={onToggle}>
					<DropDownTextHeader title={title} />
				</button>
			}
		>
			{children}
		</DropDownMenu>
	);
}
